var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"back-to-top",class:_vm.isTop ? 'back-top-after' : '',on:{"click":_vm.goTop}},[_c('b-icon',{staticClass:"back-up",attrs:{"icon":"chevron-up"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }